import * as network from './network';

// Get all pages
const getAllPages = (params) => {
  return network.get(`api/pages`, params, true);
};

// Get single page by ID
const getPageById = (pageId) => {
  return network.get(`api/pages/${pageId}`, {}, true);
};

// Get page by URL (for preview)
const getPageByUrl = (url) => {
  return network.get(`api/pages/by-url?url=${encodeURIComponent(url)}`, {}, true);
};

// Create new page
const createPage = (payload) => {
  return network.post(`api/pages`, payload, true);
};

// Update page metadata
const updatePage = (pageId, payload) => {
  return network.put(`api/pages/${pageId}`, payload, true);
};

// Delete page
const deletePage = (pageId) => {
  return network.delet(`api/pages/${pageId}`, true);
};

// Duplicate page
const duplicatePage = (pageId, payload) => {
  return network.post(`api/pages/${pageId}/duplicate`, payload, true);
};

// Publish page
const publishPage = (pageId) => {
  return network.post(`api/pages/${pageId}/publish`, {}, true);
};

// Unpublish page
const unpublishPage = (pageId) => {
  return network.post(`api/pages/${pageId}/unpublish`, {}, true);
};

// Add section to page
const addSection = (pageId, payload) => {
  return network.post(`api/pages/${pageId}/sections`, payload, true);
};

// Update section
const updateSection = (pageId, sectionId, payload) => {
  return network.put(`api/pages/${pageId}/sections/${sectionId}`, payload, true);
};

// Delete section
const deleteSection = (pageId, sectionId) => {
  return network.delet(`api/pages/${pageId}/sections/${sectionId}`, true);
};

// Reorder sections
const reorderSections = (pageId, payload) => {
  return network.put(`api/pages/${pageId}/sections/reorder`, payload, true);
};

// Get reserved routes
const getReservedRoutes = () => {
  return network.get(`api/pages/reserved-routes`, {}, true);
};

// Generate preview token for unpublished page
const generatePreviewToken = (pageId) => {
  return network.post(`api/pages/${pageId}/preview-token`, {}, true);
};

export default {
  getAllPages,
  getPageById,
  getPageByUrl,
  createPage,
  updatePage,
  deletePage,
  duplicatePage,
  publishPage,
  unpublishPage,
  addSection,
  updateSection,
  deleteSection,
  reorderSections,
  getReservedRoutes,
  generatePreviewToken,
};
